import { render } from "./Users.vue?vue&type=template&id=02dfc72a"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"
script.render = render

export default script